<template>
<div class="BaseSetPoint">
  <div class="styleSetting">
    <div class="title">
      <span class="line"></span>
      <span>样式设置</span>
    </div>
    <ul class="imgType">
      <li>
        <el-image :class="styleData.type === 'SCATTER_PLOT'?'active':''" @click="changeImgType('SCATTER_PLOT')" :src="require('@/assets/images/spot.png')" fit="cover"></el-image>
        <div class="name">散点图</div>
        <div class="check" v-if="styleData.type === 'SCATTER_PLOT'"><img src="~@/assets/images/xuanze.png" alt=""></div>
      </li>
      <li>
        <el-image :class="styleData.type === 'HEAT_MAP'?'active':''" @click="changeImgType('HEAT_MAP')" :src="require('@/assets/images/heat.png')" fit="cover"></el-image>
        <div class="name">热力图</div>
        <div class="check" v-if="styleData.type === 'HEAT_MAP'"><img src="~@/assets/images/xuanze.png" alt=""></div>
      </li>
    </ul>
    <!--    散点图-->
    <div v-show="styleData.type === 'SCATTER_PLOT'">
      <div class="form-item">
        <div class="label">颜色</div>
        <el-input v-model="styleData.color" placeholder="请输入内容" @change="onValueChange" disabled>
          <ColorPicker slot="suffix" v-model="styleData.color" @changeColor="onValueChange" :disabled="selectedIcon&&selectedIcon.module!=='FLAT'"></ColorPicker>
        </el-input>
      </div>
      <div class="form-item">
        <div class="label">图标</div>
        <el-input readonly @click.native="onClickIcon">
          <img slot="prefix" :src="selectedIcon.url" v-if="selectedIcon&&selectedIcon.module!=='FLAT'">
          <svg slot="prefix" width="2em" height="2em" :fill="styleData.color" aria-hidden="true" v-if="selectedIcon&&selectedIcon.module==='FLAT'">
            <use :xlink:href="'#icon-'+selectedIcon.name"></use>
          </svg>
          <i slot="suffix" class="el-input__icon el-icon-arrow-right"></i>
        </el-input>
      </div>
      <div class="form-item">
        <div class="label">尺寸</div>
        <el-radio-group v-model="styleData.size" @change="onValueChange">
          <el-radio label="SMALL">小</el-radio>
          <el-radio label="MIDDLE">中</el-radio>
          <el-radio label="BIG">大</el-radio>
        </el-radio-group>
      </div>
      <div class="form-item">
        <div class="label">是否聚合显示</div>
        <el-switch
          v-model="styleData.enableAggregation"
          active-color="#00A4F0"
          inactive-color="#494B4D"
          @change="onValueChange">
        </el-switch>
      </div>
      <div class="form-item">
        <div class="label">开启鼠标进入高亮</div>
        <el-switch
          v-model="styleData.isHover"
          active-color="#00A4F0"
          inactive-color="#494B4D"
          @change="onValueChange">
        </el-switch>
      </div>
      <div class="form-item" v-if="layerData.dataSourceType==='API' || (layerData.module==='sppuc' && layerData.extendConfig.isSppucData===true)">
        <div class="label">自动采样高度</div>
        <el-switch
          v-model="styleData.isAutoHeight"
          active-color="#00A4F0"
          inactive-color="#494B4D"
          @change="onValueChange">
        </el-switch>
      </div>
    </div>
    <!--    热力图-->
    <div v-show="styleData.type === 'HEAT_MAP'">
      <div class="form-item">
        <div class="label">渲染半径</div>
        <el-input-number v-model="styleData.radius" :min="1" :max="100" @change="onValueChange"></el-input-number>
      </div>
      <div class="form-item">
        <div class="label">配色方案</div>
        <el-select v-model="styleData.heatColor" placeholder="请选择" @change="changeColorRamp" ref="refSelect" :popper-append-to-body="false">
          <el-option  v-for="(item) in rampOptions"
            :key="item.id"
            :value="item.id">
            <img :src="getRampImg(item)"/>
          </el-option>
        </el-select>
      </div>
      <div class="form-item" v-show="false">
        <div class="label">开启图例</div>
        <el-switch
          v-model="styleData.enableLegend"
          active-color="#00A4F0"
          inactive-color="#494B4D"
          @change="onValueChange"
          disabled>
        </el-switch>
      </div>
    </div>
<!--    <div class="form-item">-->
<!--      <div class="label">标签字段</div>-->
<!--      <el-select v-model="styleData.label" placeholder="请选择" @change="onValueChange">-->
<!--        <el-option-->
<!--          v-for="item in labelProperties"-->
<!--          :key="item.id"-->
<!--          :label="item.name"-->
<!--          :value="item.id">-->
<!--        </el-option>-->
<!--      </el-select>-->
<!--    </div>-->
  </div>
  <div class="styleSetting" v-show="layerData.dataSourceType!=='API'">
    <div class="title">
      <span class="line"></span>
      <span>标签样式</span>
    </div>
    <div>
      <div class="form-item">
        <div class="label">标签字段</div>
        <el-select v-model="styleData.label" placeholder="请选择" @change="onLabelChange" :popper-append-to-body="false">
          <el-option
                  v-for="item in labelProperties"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="form-item">
        <div class="label">标签显示</div>
        <el-select v-model="styleData.showLabelType" placeholder="请选择" :disabled="styleData.label === 'empty'" :popper-append-to-body="false" @change="onValueChange">
          <el-option
                  v-for="item in labelShowOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="form-item">
        <div class="label">字体类型</div>
        <el-select v-model="styleData.labelStyle.labelFont" placeholder="请选择" @change="onValueChange" :popper-append-to-body="false">
          <el-option
                  v-for="item in fontFamilyList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="form-item">
        <div class="label">字体颜色</div>
        <el-input v-model="styleData.labelStyle.labelColor" placeholder="请选择" @change="onValueChange" disabled>
          <ColorPicker slot="suffix" v-model="styleData.labelStyle.labelColor"  @changeColor="onValueChange" :showAlpha="false"></ColorPicker>
        </el-input>
      </div>
      <div class="form-item">
        <div class="label">背景颜色</div>
        <el-input v-model="styleData.labelStyle.labelBackgroundColor" placeholder="请选择" @change="onValueChange" disabled>
          <ColorPicker slot="suffix" v-model="styleData.labelStyle.labelBackgroundColor" @changeColor="onValueChange"></ColorPicker>
        </el-input>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import ColorPicker from '@/components/ColorPicker/ColorPicker'
import { createColorRamp } from '@/utils/util'
import { heatMapColorConfig, getIconData } from '@/utils/markerStyles'
import { mapGetters } from 'vuex'
export default {
  name: 'BaseSetPoint',
  props: {},
  components: { ColorPicker },
  data () {
    return {
      // 样式属性
      styleData: {
        type: undefined,
        color: undefined,
        size: undefined,
        enableAggregation: undefined,
        enableLegend: undefined,
        label: undefined,
        isHover: false,
        showLabelType: 'hide',
        labelStyle: {
          labelFont: undefined,
          labelColor: undefined,
          labelBackgroundColor: undefined
        }
      },
      layerData: {},

      properties: undefined,

      fontFamilyList: [{
        value: '宋体',
        label: '宋体'
      }, {
        value: '楷体',
        label: '楷体'
      }, {
        value: '黑体',
        label: '黑体'
      }],
      labelShowOptions: [{
        value: 'hide',
        label: '不显示'
      }, {
        value: 'show',
        label: '常显'
      }, {
        value: 'distance',
        label: '层级显示'
      }],
      // rampOptions: [
      //   { width: 100, height: 10, data: [{ color: '#ff0000', value: 0 }, { color: '#ffff00', value: 1 }] },
      //   { width: 100, height: 10, data: [{ color: '#ffffff', value: 0 }, { color: '#00ff00', value: 1 }] }
      // ],
      colorRamp: undefined,
      // 选中图标图片
      selectedIcon: {
        id: 12,
        local: true,
        module: 'STEREO',
        name: 'diana',
        remark: '',
        url: '/static/textures/icon/group1/diana.png'
      }
    }
  },
  computed: {
    // bindLabel: {
    //   get: function () {
    //     if (!this.styleData.label) {
    //       return undefined
    //     }
    //     return parseInt(this.styleData.label)
    //   },
    //   set: function (value) {
    //     this.styleData.label = value
    //   }
    // },
    ...mapGetters(['markerIcons']),
    rampOptions () {
      const options = []
      for (let i = 0; i < heatMapColorConfig.length; i++) {
        options.push(
          {
            width: 110,
            height: 16,
            id: heatMapColorConfig[i].id,
            data: JSON.parse(JSON.stringify(heatMapColorConfig[i].value))
          }
        )
      }
      return options
    },
    labelProperties () {
      const properties = [{
        id: 'empty',
        name: '无'
      }, {
        id: 'markerName',
        name: '标注名称'
      }
      // , {
      //   id: 'index',
      //   name: '序号'
      // }
      ]
      if (this.properties) {
        for (let i = 0; i < this.properties.length; i++) {
          properties.push({
            id: this.properties[i].id.toString(),
            name: this.properties[i].name
          })
        }
      }
      return properties
    }
  },
  watch: {
    styleData: {
      deep: true,
      handler: function (val) {
        if (val && val.type) {
          this.selectedIcon = getIconData(val.icon)
          this.setSelectedColorRamp(val.heatColor)
        }
      }
    }
  },
  methods: {
    setData (styleData, data) {
      this.styleData = styleData
      this.properties = data.properties
      this.layerData = data

      this.selectedIcon = getIconData(styleData.icon)
      this.setSelectedColorRamp(styleData.heatColor)
    },
    changeColor (v) {
      this.$emit('layerStyleChanged', true)
    },
    getRampImg (item) {
      return createColorRamp(item)
    },
    changeColorRamp (id) {
      this.setSelectedColorRamp(id)
      this.$emit('layerStyleChanged', true)
    },
    setSelectedColorRamp (id) {
      let img
      for (let i = 0; i < this.rampOptions.length; i++) {
        if (this.rampOptions[i].id === id) {
          img = this.getRampImg(this.rampOptions[i])
        }
      }
      this.$refs.refSelect
        .$el.children[0]
        .children[0]
        .setAttribute(
          'style',
          `
          background: url(${img}) no-repeat;
          background-position: 10px center;
          background-size: 110px 20px;
          text-indent: 30px;
          background-color: rgba(255, 255, 255, 0.1);
          color: #ffffff00 !important;
          `
        )
    },
    // 修改样式类型
    changeImgType (type) {
      this.styleData.type = type
      this.$emit('layerStyleChanged', true)
    },
    // 属性值修改
    onValueChange () {
      this.$emit('layerStyleChanged', true)
    },
    onClickIcon () {
      this.$emit('showIconSelector', this.styleData.icon)
    },
    setIcon (id) {
      this.styleData.icon = id
      this.selectedIcon = getIconData(id)
      this.$emit('layerStyleChanged', true)
    },
    onLabelChange () {
      if (this.styleData.label === 'empty') {
        this.styleData.showLabelType = 'hide'
      }
      this.$emit('layerStyleChanged', true)
    }
  },
  filters: {}
}
</script>

<style lang="scss">
.BaseSetPoint{
  text-align: left;
  .title{
    color: #FFFFFF;
    font-size: 14px;
    margin-bottom: 15px;
    >.line{
      display: inline-block;
      margin-right: 4px;
      width: 3px;
      height: 10px;
      background: #00A4F0;
      border-radius: 2px;
    }
  }
  .el-input .el-input__inner{
    font-size: 12px !important;
    height: 32px !important;
  }
  .el-input__prefix{
    display: flex;
    align-items: center;
    padding-left: 10px;
    >img{
      width: 22px;
      height: 22px;
    }
  }
  .el-radio-group{
    width: 155px;
    display: flex;
    .el-radio{
      margin-right: 16px;
      transform: scale(0.9);
    }
  }
  .baseInfo{
    border-bottom: 1px solid #424345;
    padding: 16px 12px;
    box-sizing: border-box;
    .form-item{
      margin-bottom: 16px;
      >.label{
        font-size: 12px;
        font-weight: 300;
        color: #999999;
        margin-bottom: 8px;
      }
    }
    .type{
      margin-bottom: 5px;
      .label{
        font-size: 13px;
        color: rgba(255, 255, 255, 0.3);
      }
      .value{
        font-size: 13px;
        color: #00A4F0;
      }
    }
  }
  .styleSetting{
    border-bottom: 1px solid #424345;
    padding: 16px 12px;
    box-sizing: border-box;
    .imgType{
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      padding: 0 0;
      >li{
        width: 60px;
        height: 90px;
        border-radius: 6px;
        position: relative;
        margin-right: 12px;
        .el-image{
          width: 60px;
          height: 60px;
          border-radius: 6px;
          cursor: pointer;
          border: 2px solid rgba(0, 164, 240, 0);
          box-sizing: border-box;
          &.active{
            border: 2px solid rgba(0, 164, 240, 0.94);
            box-shadow: 0 0 7px rgba(25, 195, 240, 0.9);
          }
        }
        img{
          width: 100%;
          height: 100%;
        }
        .name{
          font-size: 12px;
          font-family: Source Han Sans SC;
          font-weight: 400;
          color: #999999;
          text-align: center;
          transform: translateY(-2px);
        }
        .check{
          position: absolute;
          right: 0;
          top: 40px;
        }
      }
    }
    .form-item{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      .label{
        width: 120px;
        font-size: 12px;
        color: #999999;
      }
    }
  }
}
</style>
